"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canRefundPerformanceBond = canRefundPerformanceBond;
function canRefundPerformanceBond(applyDetail) {
  if (!applyDetail) return false;
  var bond = Number(applyDetail.performanceBond);
  return Number(applyDetail.applyStatus) === 1 && Number(applyDetail.performancePayStatus) === 2 && !Number.isNaN(bond) && bond > 0;
}